/* ============================================================
   COCO ROSA — Funcionamiento del tema (nubes, Cocito, videos, buscador…)
   Cada parte solo se activa si existe en la página.
   ============================================================ */
(() => {
  if (window.__cocoListo) return; // por si el archivo se carga dos veces
  window.__cocoListo = true;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const scrollMode = reduceMotion ? "auto" : "smooth";
  const escapeHtml = (t) => String(t).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* ---------- Barra de anuncios: Cocito cruza con un mensaje por vuelta ---------- */
  function initFlyer() {
    const flyer = $("#flyer");
    const text = $("#flyerText");
    if (!flyer || !text) return;
    const messages = $$("#announceList li").map((li) => li.textContent.trim()).filter(Boolean);
    if (!messages.length) return;
    let index = 0;
    text.textContent = messages[0];
    const setSpeed = () => {
      const current = text.textContent;
      const widest = Math.max(...messages.map((t) => { text.textContent = t; return flyer.offsetWidth; }));
      text.textContent = current;
      flyer.style.setProperty("--fly-dur", `${((window.innerWidth + widest) / 85).toFixed(1)}s`);
    };
    setSpeed();
    document.fonts?.ready.then(setSpeed);
    window.addEventListener("resize", setSpeed);
    flyer.addEventListener("animationiteration", (e) => {
      if (e.target !== flyer) return;
      index = (index + 1) % messages.length;
      text.textContent = messages[index];
    });
  }

  function initHeader() {
    const header = $("#siteHeader");
    if (!header) return;
    const update = () => header.classList.toggle("is-scrolled", window.scrollY > 8);
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  /* ---------- Menú lateral y buscador ---------- */
  let lastFocus = null;
  function openLayer(id) {
    const layer = document.getElementById(id);
    if (!layer) return;
    lastFocus = document.activeElement;
    layer.hidden = false;
    document.body.classList.add("no-scroll");
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute("aria-expanded", "true"));
    void layer.offsetWidth;
    layer.classList.add("is-open");
    const input = $("input[type='search']", layer);
    if (input) renderSearch(input.value);
    setTimeout(() => (input || $("a, button", $(".drawer-body", layer) || layer))?.focus(), 60);
  }
  function closeLayer(id, restoreFocus = true) {
    const layer = document.getElementById(id);
    if (!layer || layer.hidden) return;
    layer.classList.remove("is-open");
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute("aria-expanded", "false"));
    setTimeout(() => {
      layer.hidden = true;
      if (!$$(".coco .capa").some((l) => !l.hidden)) document.body.classList.remove("no-scroll");
    }, 420);
    if (restoreFocus) lastFocus?.focus?.();
  }
  function trapFocus(e) {
    const layer = $$(".coco .capa").find((l) => !l.hidden);
    if (!layer || e.key !== "Tab") return;
    const items = $$("a[href], button:not([disabled]), input", layer).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // Buscador con los productos reales de la tienda (búsqueda predictiva de Shopify)
  let searchTimer, searchCtrl;
  function renderSearch(raw) {
    const box = $("#cocoSearchResults");
    if (!box) return;
    const q = raw.trim();
    if (!q) {
      const chips = $$("#cocoChips a").map((a) => a.outerHTML).join("");
      box.innerHTML = chips ? `<p class="sr-title">Te puede interesar</p><div class="sr-chips">${chips}</div>` : "";
      return;
    }
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      searchCtrl?.abort();
      searchCtrl = new AbortController();
      const base = (window.routes && window.routes.predictive_search_url) || "/search/suggest";
      const url = `${base}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`;
      try {
        const res = await fetch(url, { signal: searchCtrl.signal });
        const data = await res.json();
        const results = data.resources?.results || {};
        const products = results.products || [];
        const collections = results.collections || [];
        const allUrl = `${(window.routes && window.routes.search_url) || "/search"}?q=${encodeURIComponent(q)}`;
        box.innerHTML = [
          collections.length ? `<p class="sr-title">Colecciones</p><div class="sr-chips">${collections.slice(0, 4).map((c) => `<a class="sr-chip" href="${c.url}">${escapeHtml(c.title)}</a>`).join("")}</div>` : "",
          products.length
            ? `<p class="sr-title">Joyitas</p><div class="sr-list">${products.map((p) => `
                <a class="sr-item" href="${p.url}">
                  ${p.image ? `<img src="${p.image}${p.image.includes("?") ? "&" : "?"}width=160" alt="" loading="lazy">` : ""}
                  <span><span class="sr-name">${escapeHtml(p.title)}</span><span class="sr-price">$${escapeHtml(p.price)}</span></span>
                </a>`).join("")}</div>`
            : `<p class="sr-empty">No encontramos “${escapeHtml(q)}”. Prueba con otra palabra.</p>`,
          `<a class="btn btn-light sr-all" href="${allUrl}">Ver todos los resultados ${ARROW}</a>`,
        ].join("");
      } catch (err) {
        if (err.name !== "AbortError") box.innerHTML = `<p class="sr-empty">No pudimos buscar en este momento.</p>`;
      }
    }, 220);
  }

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal() {
    if (!document.documentElement.classList.contains("js-anim")) return;
    window.revealReady = true;
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add("is-in");
      io.unobserve(e.target);
    }), { rootMargin: "0px 0px -6% 0px", threshold: 0.12 });
    $$(".coco [data-reveal]:not(.is-in), .coco [data-reveal-group]:not(.is-in)").forEach((el) => io.observe(el));
  }

  /* ---------- Carruseles ---------- */
  function initCarousel(root) {
    const track = $("[data-track]", root);
    if (!track) return;
    const dotsBox = $("[data-dots]", root);
    const prev = $("[data-prev]", root);
    const next = $("[data-next]", root);
    const items = () => [...track.children];
    function update() {
      const max = track.scrollWidth - track.clientWidth;
      const scrollable = max > 4;
      root.classList.toggle("is-scrollable", scrollable);
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (dotsBox && scrollable) {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = 0, bestDistance = Infinity;
        items().forEach((el, i) => {
          const d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - center);
          if (d < bestDistance) { bestDistance = d; best = i; }
        });
        $$(".car-dot", dotsBox).forEach((d, i) => {
          d.classList.toggle("is-active", i === best);
          d.setAttribute("aria-current", i === best ? "true" : "false");
        });
      }
    }
    const goTo = (el) => track.scrollTo({ left: el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2, behavior: scrollMode });
    if (dotsBox) {
      dotsBox.innerHTML = items().map((_, i) => `<button class="car-dot" type="button" aria-label="Ver tarjeta ${i + 1} de ${items().length}"></button>`).join("");
      dotsBox.addEventListener("click", (e) => {
        const dot = e.target.closest(".car-dot");
        if (dot) goTo(items()[[...dotsBox.children].indexOf(dot)]);
      });
    }
    prev?.addEventListener("click", () => track.scrollBy({ left: -track.clientWidth * 0.85, behavior: scrollMode }));
    next?.addEventListener("click", () => track.scrollBy({ left: track.clientWidth * 0.85, behavior: scrollMode }));
    let ticking = false;
    track.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------- Parallax suave de los detalles ---------- */
  function initParallax() {
    if (reduceMotion) return;
    const els = $$(".coco [data-parallax]");
    if (!els.length) return;
    let ticking = false;
    const run = () => {
      ticking = false;
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) return;
        el.style.translate = `0 ${((r.top + r.height / 2) - vh / 2) * parseFloat(el.dataset.parallax)}px`;
      });
    };
    window.addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- Visor de imágenes (capturas de clientes) ---------- */
  function initViewer() {
    const dlg = $("#cocoVisor");
    if (!dlg) return;
    const pic = $("img", dlg);
    document.addEventListener("click", (e) => {
      const b = e.target.closest("[data-ampliar]");
      if (!b) return;
      pic.src = b.dataset.ampliar;
      pic.alt = b.dataset.alt || "";
      if (typeof dlg.showModal === "function") dlg.showModal(); else window.open(b.dataset.ampliar, "_blank");
    });
    $(".visor-close", dlg)?.addEventListener("click", () => dlg.close());
    dlg.addEventListener("click", (e) => { if (e.target === dlg) dlg.close(); });
  }

  /* ---------- Videos de la portada ---------- */
  function initHeroVideos() {
    const arches = $("#arches");
    const button = $("#videoToggle");
    if (!arches || !button) return;
    const videos = $$(".arch-video", arches);
    const label = $("span", button);
    let paused = reduceMotion;
    let visible = true;
    const sync = () => {
      button.classList.toggle("is-paused", paused);
      button.setAttribute("aria-pressed", String(paused));
      label.textContent = paused ? "Reproducir videos" : "Pausar videos";
      videos.forEach((v) => { if (paused || !visible) v.pause(); else v.play()?.catch(() => {}); });
    };
    button.addEventListener("click", () => { paused = !paused; sync(); });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); }, { threshold: 0.1 }).observe(arches);
    }
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") sync(); });
    sync();
  }

  /* ---------- Preguntas frecuentes ---------- */
  function initFaq() {
    $$(".coco .faq-list").forEach((list) => list.addEventListener("click", (e) => {
      const button = e.target.closest(".faq-q");
      if (!button) return;
      const item = button.closest(".faq-item");
      const open = !item.classList.contains("is-open");
      item.classList.toggle("is-open", open);
      button.setAttribute("aria-expanded", String(open));
      $(".faq-a > div", item).inert = !open;
    }));
  }

  // La cartita sale de la mano de Cocito, da la vuelta por el corazón y vuela hacia las preguntas
  function initLetter() {
    const art = $("#faqArt");
    if (!art) return;
    const path = $(".faq-line", art);
    const letter = $(".letter", art);
    const len = path.getTotalLength();
    const place = (p) => {
      const ctm = path.getScreenCTM();
      if (!ctm) return;
      const box = art.getBoundingClientRect();
      const at = (q) => { const pt = path.getPointAtLength(len * q); return new DOMPoint(pt.x, pt.y).matrixTransform(ctm); };
      const a = at(p), b = at(Math.min(1, p + 0.01));
      const angle = Math.max(-25, Math.min(25, Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI));
      letter.style.transform = `translate(${(a.x - box.left).toFixed(1)}px, ${(a.y - box.top).toFixed(1)}px) rotate(${angle.toFixed(1)}deg)`;
      letter.style.opacity = p < 0.08 ? p / 0.08 : p > 0.92 ? (1 - p) / 0.08 : 1;
    };
    if (reduceMotion) { place(0.97); letter.style.opacity = 1; return; }
    const duration = 5200, rest = 1400;
    let raf = 0, t0 = 0;
    const frame = (now) => {
      if (!t0) t0 = now;
      const cycle = (now - t0) % (duration + rest);
      if (cycle <= duration) place(cycle / duration); else letter.style.opacity = 0;
      raf = requestAnimationFrame(frame);
    };
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { if (!raf) raf = requestAnimationFrame(frame); }
      else { cancelAnimationFrame(raf); raf = 0; }
    }).observe(art);
  }

  /* ---------- Video de Jari (se carga solo cuando aparece) ---------- */
  function initStoryVideo() {
    const video = $("#storyVideo");
    if (!video || reduceMotion || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        if (!video.src) video.src = video.dataset.src;
        video.play()?.catch(() => {});
      } else {
        video.pause();
      }
    }, { threshold: 0.25 }).observe(video);
  }

  /* ---------- Colección: ordenar ---------- */
  function initSort() {
    const sel = $("#cocoSort");
    if (!sel) return;
    sel.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sel.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  }

  /* ---------- Arranque ---------- */
  document.addEventListener("click", (e) => {
    const t = e.target.closest(".coco button, .coco a, .coco .capa-fondo");
    if (!t) return;
    if (t.dataset.open) { e.preventDefault(); openLayer(t.dataset.open); }
    else if ("close" in t.dataset) closeLayer(t.closest(".capa").id);
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") { $$(".coco .capa").forEach((l) => closeLayer(l.id)); return; }
    trapFocus(e);
  });
  $("#cocoSearchInput")?.addEventListener("input", (e) => renderSearch(e.target.value));

  initFlyer();
  initHeader();
  initViewer();
  initHeroVideos();
  initFaq();
  initLetter();
  initStoryVideo();
  initSort();
  $$(".coco [data-carousel]").forEach(initCarousel);
  initReveal();
  initParallax();
})();
